The latest event to include.
